import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 1rem;

  h1 {
    font-weight: 700;
    font-size: 24px;
    text-align: center;
  }

  span {
    font-size: 16px;
    font-family: Roboto, sans-serif;
    margin: 1rem 0;
  }

  .input-link {
    width: 537px;
    height: 49px;
    border-radius: 4px 0px 0px 4px;
    padding: 16px;
    background-color: #f5f5f5;
    color: #616161;
    border: none;
    outline: none;
  }

  .copy-button,
  .download-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background-color: #6c5af4;
    border: none;
    outline: none;
    padding: 1rem;
    width: 160px;
    height: 50px;
    font-size: 16px;
    font-weight: 700;
  }

  .copy-button {
    border-radius: 0 4px 4px 0;
  }

  .download-button {
    border-radius: 8px;
  }
`;
